import {
    Component, Input, OnInit, OnDestroy,
    IterableDiffers, DoCheck, Output, EventEmitter
} from '@angular/core';
import {DataService} from "../../services/data.service";
import {ProjectManagementService} from "../../services/project-management.service";
import {FrontEndService} from "../../services/front-end.service";
import {CreateWallPostComponent} from "../create-wall-post/create-wall-post.component";
import {ModalDismissReasons, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Observable} from "rxjs/Rx";
import {LogService} from "../../services/log.service";


@Component({
    selector: 'app-wall-reply',
    templateUrl: './wall-reply.component.html',
    styleUrls: ['./wall-reply.component.scss', '../project-wall/project-wall.component.scss']
})
export class WallReplyComponent implements OnInit, DoCheck, OnDestroy {

    @Input() replies = [];
    @Input() isParent = false;
    // Pass download function.
    @Input() download_file;
    @Input() currentState: string;
    @Output() fetchReplies = new EventEmitter<number>();

    public modalRef: NgbModalRef;

    // Timer every 30 secs.
    timer = Observable.timer(0, 30000);
    timer_subscription = [];

    // for single post timer
    wait_timer = Observable.timer(0, 1000);
    wait_timer_subscription: any;

    iterableDiffer: any;

    /**
     * Get dismiss reason for modal
     * @param reason
     * @returns {string}
     */
    private static getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    constructor(
        private project_management_service: ProjectManagementService,
        public dataService: DataService,
        public frontEndService: FrontEndService,
        private modalService: NgbModal,
        private logService: LogService,
        private _iterableDiffers: IterableDiffers
    ) {
        this.iterableDiffer = this._iterableDiffers.find([]).create(null);
    }

    ngOnInit() {
        if(this.currentState === 'singlePost') {
            this.wait_timer_subscription = this.wait_timer.subscribe(() => {
                if (this.replies.length > 0) {
                    this.showReply(0, true);
                    this.wait_timer_subscription.unsubscribe();
                }
            });
        }
    }

    ngDoCheck() {
        const changes = this.iterableDiffer.diff(this.replies);
        if (changes) {
            if(this.isParent) {
                this.setShowReplies();
            }
        }
    }

    ngOnDestroy() {
        // this.timer_subscription.unsubscribe
        for(const i in this.timer_subscription) {
            this.timer_subscription[i]['timer'].unsubscribe();
        }
        this.timer_subscription = [];
    }

    setShowReplies() {
        this.replies.forEach((wall_post, key) => {
            // To show replies by default
            this.showReply(key, false);
        });
    }

    fetch_comment_replies(index) {
        this.project_management_service.wall_get(this.dataService.selected_project, 0, 0, (response) => {
            this.replies[index]["replyLoading"] = false;
            this.replies[index]["replies"] = response["data"];
            if (response["data"]) {
                this.replies[index]["wall_reply_count"] = response["data"].length;
            } else {
                this.replies[index]["wall_reply_count"] = 0;
            }

        }, this.replies[index]["id"]);
    }

    showReply(index, showReply) {

        this.replies[index]["showReply"] = showReply;
        this.replies[index]["replyLoading"] = true;

        if (showReply) {
            this.timer_subscription.push({
                "index": index,
                "timer": this.timer.subscribe(() => {
                    this.fetch_comment_replies(index);
                })

            });
        } else {
            const temp = this.dataService.get_array_details(
                this.timer_subscription,
                "index",
                index
            );

            if (temp && temp.hasOwnProperty('timer')) {
                temp['timer'].unsubscribe();
                const i = this.timer_subscription.indexOf(temp);
                this.timer_subscription.splice(i, 1);
            }
        }

    }

    openModal(post, indexNo) {
        this.modalRef = this.modalService.open(CreateWallPostComponent, { windowClass: "create-post-modal" });

        if (post.hasOwnProperty('project_wall_post')) {
            // This is for nested reply.
            this.modalRef.componentInstance.wallPostId = post["project_wall_post"];
            this.modalRef.componentInstance.wallReplyId = post["id"];
        } else {
            // this is for 1st level reply only.
            this.modalRef.componentInstance.wallPostId = post["id"];
        }

        this.modalRef.componentInstance.projectId = post["project"];
        this.modalRef.componentInstance.indexNo = indexNo;
        this.modalRef.componentInstance.modalRef = this.modalRef;
        this.modalRef.result.then((result) => {
            if (!this.isParent) {
                this.fetchReplies.emit();
            } else {
                this.fetch_comment_replies(this.dataService.wall_list.findIndex(function(item) {
                    return item.id === result.project_wall_post
                }));
            }
        }, (reason) => {
            const closeResult = `Dismissed ${WallReplyComponent.getDismissReason(reason)}`;
        });
    }

    deleteWallPost(postDetails, isDelete: boolean) {
        let message = 'restore_post_confirmation';
        if (isDelete) {
            message = 'delete_post_confirmation';
        }
        const wallId = postDetails.id;
        let parentId = 0;
        if (!this.isParent) {
            parentId = postDetails.project_wall_post;
        }
        this.frontEndService.confirmAlert('confirm', message, 'warning', (result) => {
            if (result.value) {
                this.project_management_service.deleteWallPost(wallId, parentId, this.isParent, this.dataService.selected_project, (response) => {
                    if (response.status) {
                        this.replies.forEach((post) => {
                            if (post.id === wallId) {
                                let successMessage = "post_restored_successfully";
                                if (isDelete) {
                                    successMessage = "post_deleted_successfully";
                                }
                                this.frontEndService.addToast("success", successMessage, "success");
                                post.is_active = !post.is_active;
                            }
                        });
                    }
                });
            }
        });
    }

    onIntersection(event, index) {
        if (this.isParent) {
            this.showReply(index, event.visible);
        }
    }

    fetchReplyByIndex(index) {
        this.logService.printLog("Index of reply - ", index);
        if (this.isParent) {
            this.fetch_comment_replies(index);
        } else {
            this.fetchReplies.emit();
        }
    }
}
